import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    token: localStorage.getItem('token') || null,
    expiresAt: localStorage.getItem('expiresAt') || null,
    currentUser: JSON.parse(localStorage.getItem('user') || 'null') || null,
    roles: []
  },


  mutations: {

    setToken(state, { token, expiresAt }) {
      state.token = token
      if (token === null) {
        localStorage.removeItem('token')
        localStorage.removeItem('expiresAt')
      } else {
        localStorage.setItem('token', token)
        localStorage.setItem('expiresAt', expiresAt)
        state.expiresAt = expiresAt
      }
    },

    setCurrentUser(state, { user, roles = [] }) {
      state.currentUser = user
      state.roles = roles
      if (user === null) {
        localStorage.removeItem('user')
      } else {
        localStorage.setItem('user', JSON.stringify(user))
      }
    }

  },

  actions: {

    async login({ commit, state }, data) {
      const { token, expiresAt } = await actionClient.post('auth', data)
      // const token = '123456'
      commit('setToken', { token, expiresAt })
      const user = await actionClient.get('me')
      // const user = { name: '开心测试' }
      commit('setCurrentUser', { user })
    },

    async sendCode({ commit, state }, data) {
      await actionClient.post('send-code', data)
    },

    logout({ commit }) {
      commit('setToken', { token: null })
      commit('setCurrentUser', { user: null })
    },
    async resetPassword({ commit }, { email, code, password }) {
      const data = { email, code, password }
      await actionClient.post('reset-password', data)
    },
    async update(_, payload) {
      await actionClient.post('me', payload)
    }

  }


}
